const infoResponsive = gsap.matchMedia();

infoResponsive.add("(min-width: 769px)", () => {
    gsap.set('.content-column-text-row', {
        opacity: 0,
    })
    const at4 = gsap.timeline({
        scrollTrigger: {
            trigger: ".content-column-text",
            start: "0% 0%",
            end: "60% 50%",
            scrub: true,
            // markers: true,
        }
    })
    at4.to('.content-column-text-row', {
        opacity: 1,
        stagger: 1,
    }, 'at4')
});

const rotatingIcone = gsap.timeline({
    scrollTrigger: {
        trigger: ".content-column-wrapp",
        start: "0% 0%",
        end: "100% 50%",
        scrub: true,
        // markers: true,
    }
})
rotatingIcone.to('.rotating-symbol img', {
    rotate: 1092,
    stagger: 0.5,
})
// for responsive 
infoResponsive.add("(min-width: 769px)", () => {
    rotatingIcone.to('.rotating-symbol-wrap', {
        x: "100%",
    }, 'at5')
    rotatingIcone.to('.rotating-symbol', {
        x: "-50%",
    }, 'at5')
})

infoResponsive.add("(max-width: 768px)", () => {
    rotatingIcone.to('.rotating-symbol-wrap', {
        x: "0%",
    }, 'at5')
    rotatingIcone.to('.rotating-symbol', {
        x: "40vw",
    }, 'at5')
})